import PropTypes from 'prop-types';
import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { add, load } from '../../../reducers/costCodeCategory/costCodeCategory.actions';
import { costCodeCategories, loading } from '../../../reducers/costCodeCategory/costCodeCategory.reducer';
import { Spinner } from '../../Spinner/Spinner';
import './AdminCostCodeCategories.css';
import ConnectedCostCodeCategoryForm from './CostCodeCategoryForm/CostCodeCategoryForm';

export class AdminCostCodeCategories extends React.Component {
  componentDidMount() {
    this.props.load();
  }

  render() {
    return (
      <span>
        <Spinner isLoading={this.props.areCostCodeCategoriesLoading} />
        <Row style={{ 'margin-bottom': '15px' }}><Col><Button onClick={this.props.addCostCodeCategories} bsStyle="primary">Add New Cost Code Category</Button></Col></Row>
        {this.props.costCodeCategories.map(costCodeCategory => (
          <Row key={costCodeCategory.id}>
            <Col>
              <ConnectedCostCodeCategoryForm costCodeCategory={costCodeCategory} />
            </Col>
          </Row>
          ))}
        <Row><Col><Button onClick={this.props.addCostCodeCategories} bsStyle="primary">Add New Cost Code Category</Button></Col></Row>
      </span>
    );
  }
}

AdminCostCodeCategories.propTypes = {
  load: PropTypes.func.isRequired,
  addCostCodeCategories: PropTypes.func.isRequired,
  areCostCodeCategoriesLoading: PropTypes.bool.isRequired,
  costCodeCategories: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export const mapStateToProps = state => ({
  areCostCodeCategoriesLoading: loading(state),
  costCodeCategories: costCodeCategories(state),
});

export const mapDispatchToProps = dispatch => ({
  load: () => dispatch(load()),
  addCostCodeCategories: () => dispatch(add()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminCostCodeCategories);



// WEBPACK FOOTER //
// ./src/components/Admin/CostCodeCategories/AdminCostCodeCategories.jsx